<ng-container *ngIf="category as c">
  <div class="details-surface row rounded-2 mt-2 mx-0 w-100">
    <div class="col text-center">
      <span class="details-primary-text fs-lg p-1">{{ c.title }}</span>
      <i
        *ngIf="icon"
        class="{{ icon }}"
        [ngStyle]="{ transform: 'rotate(' + bearing + 'deg)' }"
      ></i>
    </div>
  </div>
  <div class="row justify-content-around mt-2 mx-0 w-100">
    <!-- Special case for condition category. TODO Resolve in the future -->
    <div *ngIf="c.title !== 'Conditions'" class="col-12 col-sm-3 gy-1 text-center">
      <span class="details-secondary-text fs-xl text-truncate"
        >{{ c.items[0]?.value }}{{ c.items[0]?.value ? c.items[0]?.unit : '' }}</span
      >
    </div>
    <div class="col-6 col-sm-3 gy-2 text-center" *ngIf="c.title === 'Conditions'">
      <div class="row text-start">
        <span class="details-secondary-text fs-xs"
          >{{ c.items[0]?.value }}{{ c.items[0]?.value ? c.items[0]?.unit : '' }}</span
        >
      </div>
      <div class="row text-start">
        <span class="fs-2xs">{{ c.items[0]?.description }}</span>
      </div>
    </div>

    <app-details-item
      *ngIf="c.items[1] as item"
      class="col-6 col-sm-3 gy-2 text-start"
      [description]="item.description"
      [value]="item.value"
      [unit]="item.unit"
    ></app-details-item>
    <app-details-item
      *ngIf="c.items[2] as item"
      class="col-6 col-sm-3 gy-2 text-start"
      [description]="item.description"
      [value]="item.value"
      [unit]="item.unit"
    ></app-details-item>

    <app-details-item
      *ngIf="c.items[3] as item"
      class="col-6 col-sm-3 gy-2 text-start"
      [description]="item.description"
      [value]="item.value"
      [unit]="item.unit"
    ></app-details-item>
  </div>
</ng-container>
